import notfoundcomponent from '../pages/NotFoundComponent.vue'
import forbiddencomponent from '../pages/_403.vue'
// import googlemaps from '../components/googlemaps.vue'
// import SKFPraktijkenRegister from '../pages/register/SKFPraktijkenRegister.vue'
import errortests from '../pages/testsvoorsentry.vue'
import Spe032MemberCard from '../pages/prof/Spe032MemberCard.vue'
import Spe015Main from '../pages/prof/Spe015PrPersonAutorisedAdmin/main.vue'
import Spe015Toevoegen from '../pages/prof/Spe015PrPersonAutorisedAdmin/toevoegen.vue'
import Spe015Overzicht from '../pages/prof/Spe015PrPersonAutorisedAdmin/overzicht.vue'
import Spe020PrStatusoverzicht from '../pages/prof/Spe020PrStatusoverzicht.vue'
import Spe021PeActiviteiten from '../pages/allroles/SPE021PEActiviteiten.vue'
import Spe026PrDetailPE from '../pages/prof/Spe026PrDetailPE.vue'
import Spe671PrExtOrgMyAdmins from '../pages/prof/Spe671PrExtOrgMyAdmins.vue'
import Spe673PRExtOrgAdmindetail from '../pages/prof/SPE673PRExtOrgAdmindetail.vue'
import Spe005Main from '../pages/public/SPE005PrHelpdesk/main.vue'
import Spe005Edu from '../pages/public/SPE005PrHelpdesk/edu.vue'
import Spe005Prof from '../pages/public/SPE005PrHelpdesk/prof.vue'
import agenda from '../pages/public/Agenda/Main.vue'

import PEmenuAspDotNetWrapper from '../pages/PEmenuAspDotNetWrapper.vue'

import SRPOMain from '../pages/allroles/SRPO/SRPOMain.vue'
import SRPOToevoegen from '../pages/allroles/SRPO/SRPOToevoegen.vue'
import SRPOToevoegenConcept from '../pages/allroles/SRPO/SRPOToevoegenConcept.vue'
import SRPOOverzicht from '../pages/allroles/SRPO/SRPOOverzicht.vue'
import SRPOBericht from '../pages/allroles/SRPO/SRPOBericht.vue'

import VMSWbestuurders from '../pages/prof/VMSWbestuurders.vue'
import VMSWbestuurdersDetail from '../pages/prof/VMSWbestuurdersDetail.vue'
import VMSWaandeelhouders from '../pages/prof/VMSWaandeelhouders.vue'
import VMSWaandeelhoudersDetail from '../pages/prof/VMSWaandeelhoudersDetail.vue'
import VVNpersonHandelingen from '../pages/allroles/VVNpersonHandelingen.vue'
import PointsOfInterest from '../pages/public/PointsOfInterest.vue'
import SPE610ExtOrgSelection from '../pages/extorg/SPE610ExtOrgSelection.vue'
import SPE620ExtOrgAccountAanvragen from '../pages/extorg/SPE620ExtOrgAccountAanvragen.vue'
import SPE650BHExtOrgDetails from '../pages/extorg/SPE650BHExtOrgDetails.vue'
import SPE203Meldingen from '../pages/allroles/SPE203Meldingen.vue'
import SPE696PatientEnquete from '../pages/allroles/SPE696PatientEnquete.vue'
import SPE697PatientEnqueteDetail from '../pages/allroles/SPE697PatientEnqueteDetail.vue'

import Spe010Persoonsgegevens from '../pages/beheer/Spe010Persoonsgegevens.vue'

import SKFPraktijken from '../pages/public/SKFPraktijken.vue'
import { store } from '@/store'
import { util } from 'pevueglobal'
export default [
  {
    path: '/peapp/errortests/',
    component: errortests
  },
  { path: '/peapp/403',
    component: forbiddencomponent,
    name: '403',
  },
  {
    path: '/peapp/public/PointsOfInterest/:profgroupID',
    component: PointsOfInterest,
    name: 'PointsOfInterest',
    beforeEnter: (to, from, next) => {
      // PublicProfgroup
      util.UsetCookie('PublicProfgroup', to.params.profgroupID)

      addBodyClass('public_PointsOfInterest')

      store.commit('setMenuOptions', {
        loadTopbanner: true,
        loadLangChoice: false,
        loadMenu: false,
        loadFixedLinks: false
      })

      next()
    },
    meta: {
      BodyScroll: false
    }
  },
  {
    path: '/peapp/public/SKFPraktijken/:profgroupID',
    component: SKFPraktijken,
    name: 'SKFPraktijken',
    beforeEnter: (to, from, next) => {
      // PublicProfgroup
      util.UsetCookie('PublicProfgroup', to.params.profgroupID)

      addBodyClass('public_SKFPraktijken')

      store.commit('setMenuOptions', {
        loadTopbanner: true,
        loadLangChoice: false,
        loadMenu: false,
        loadFixedLinks: false
      })

      next()
    },
    meta: {
      BodyScroll: false
    }
  },
  {
    path: '/peapp/:role/Spe032MemberCard',
    component: Spe032MemberCard,
    name: 'Spe032MemberCard',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_Spe032MemberCard')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe015PrPersonAutorisedAdmin',
    component: Spe015Main,
    name: 'Spe015Main',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_Spe015PrPersonAutorisedAdmin')
      next()
    },
    children: [
      // UserHome will be rendered inside User's <router-view>
      // when /peapp/:role/Spe015PrPersonAutorisedAdmin/add is matched
      { path: 'add', component: Spe015Toevoegen },

      // UserProfile will be rendered inside User's <router-view>
      // when /peapp/:role/Spe015PrPersonAutorisedAdmin/overview is matched
      { path: 'overview', component: Spe015Overzicht }
    ]
  },
  {
    path: '/peapp/:role/SRPOOvereenkomsten',
    component: SRPOMain,
    name: 'SRPOMain',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_SRPOOvereenkomsten bh_SRPOOvereenkomsten')
      next()
    },
    children: [
      // UserHome will be rendered inside User's <router-view>
      // when /peapp/:role/SRPOOvereenkomsten/toevoegen is matched
      { name: 'toevoegen', path: 'toevoegen', component: SRPOToevoegen },
      // when /peapp/:role/SRPOOvereenkomsten/toevoegenConcept is matched
      { name: 'toevoegenConcept', path: 'toevoegenConcept', component: SRPOToevoegenConcept },
      { name: 'wijzigConcept', path: 'wijzigConcept/:conceptId', component: SRPOToevoegenConcept },
      { name: 'bericht', path: 'bericht', component: SRPOBericht },
      // when /peapp/:role/SRPOOvereenkomsten/overzicht is matched
      { name: 'overzicht', path: 'overzicht', component: SRPOOverzicht }
    ]
  },
  {
    path: '/peapp/public/SPE005PrHelpdesk/',
    component: Spe005Main,
    name: 'Spe005Main_Edu',
    beforeEnter: (to, from, next) => {
      addBodyClass('public_SPE005PrHelpdesk')
      next()
    },
    children: [
      // when /peapp/SPE005PrHelpdesk/edu is matched
      { path: 'edu', component: Spe005Edu }
    ]
  },
  {
    path: '/peapp/public/SPE005PrHelpdesk/:profgroup',
    component: Spe005Main,
    name: 'Spe005Main',
    beforeEnter: (to, from, next) => {
      addBodyClass('public_SPE005PrHelpdesk')
      next()
    },
    children: [
      // when /peapp/SPE005PrHelpdesk/edu is matched
      // { path: 'edu', component: Spe005Edu },
      // when /peapp/SPE005PrHelpdesk/prof is matched. admin is the same page as prof
      { path: 'prof', component: Spe005Prof },
      { path: 'admin', component: Spe005Prof }
    ]
  },
  {
    path: '/peapp/public/agenda/:profgroup',
    component: agenda,
    name: 'agenda',
    beforeEnter: (to, from, next) => {
      addBodyClass('bodyPublic public_index')
      store.commit('setMenuOptions', {
        loadTopbanner: true,
        loadLangChoice: true,
        loadMenu: false,
        loadFixedLinks: false
      })
      next()
    }
  },
  {
    path: '/peapp/public/agenda/:profgroup/:langid',
    component: agenda,
    name: 'agendaLanguage',
    beforeEnter: (to, from, next) => {
      addBodyClass('bodyPublic public_index')
      store.commit('setMenuOptions', {
        loadTopbanner: true,
        loadLangChoice: true,
        loadMenu: false,
        loadFixedLinks: false
      })
      next()
    }
  },
  {
    path: '/peapp/:role/Spe020PrStatusoverzicht',
    component: Spe020PrStatusoverzicht,
    name: 'Spe020PrStatusoverzicht',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_Spe020PrStatusoverzicht')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe021PrPeActiviteiten',
    component: Spe021PeActiviteiten,
    name: 'Spe021PrPeActiviteiten',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_spe021_pr_peactiviteiten')
      next()
    }
  },
  {
    path: '/peapp/:role/meldingen',
    component: SPE203Meldingen,
    name: 'SPE203Meldingen',
    beforeEnter: (to, from, next) => {
      addBodyClass('SPE203Meldingen')
      next()
    }
  },
  {
    path: '/peapp/:role/SPE021BHPEActiviteiten/:personid/:boolPopupModus',
    component: Spe021PeActiviteiten,
    name: 'SPE021BHPEActiviteiten',
    // Als aanroep het vanaf popup versie is (SPE021_BH_PEActiviteitenPopup)
    // Dan geen menu en fixed linkes tonen
    beforeEnter: (to, from, next) => {
      if (parseInt(to.params.boolPopupModus) > 0) {
        store.commit('setMenuOptions', {
          loadTopbanner: false,
          loadLangChoice: false,
          loadMenu: false,
          loadFixedLinks: false
        })
        addBodyClass('prof_spe021_pr_peactiviteiten')
        next()
      } else {
        addBodyClass('prof_spe021_pr_peactiviteiten')
        next()
      }
    }
  },
  {
    path: '/peapp/:role/Spe026PrDetailPE/autonumID/:autonumID/:showtitle/:showbackbtn',
    component: Spe026PrDetailPE,
    name: 'Spe026PrDetailPE',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_Spe026PrDetailPE')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe026PrDetailPE/targetID/:targetID/:showtitle/:showbackbtn',
    component: Spe026PrDetailPE,
    name: 'Spe026PrDetailPE_targetid',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_Spe026PrDetailPE')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe026PrDetailPE/lasttarget/:lasttarget/:showtitle/:showbackbtn',
    component: Spe026PrDetailPE,
    name: 'Spe026PrDetailPE_lasttarget',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_Spe026PrDetailPE')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe671PrExtOrgMyAdmins',
    component: Spe671PrExtOrgMyAdmins,
    name: 'Spe671PrExtOrgMyAdmins',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_spe671_pr_extorg_myadmins')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe673PRExtOrgAdmindetail',
    component: Spe673PRExtOrgAdmindetail,
    name: 'Spe673PRExtOrgAdmindetail',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_spe673_pr_extorg_admin_detail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWbestuurders',
    component: VMSWbestuurders,
    name: 'VMSWbestuurders',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWbestuurders')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWbestuurders/inzien/:personid',
    component: VMSWbestuurders,
    name: 'VMSWbestuurdersInzien',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWbestuurders')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWbestuurdersDetail',
    component: VMSWbestuurdersDetail,
    name: 'VMSWbestuurdersDetail',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWbestuurdersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWbestuurdersDetail/inzien/:personid',
    component: VMSWbestuurdersDetail,
    name: 'VMSWbestuurdersDetailInzien',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWbestuurdersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWbestuurdersDetail/update/:bestuurderid',
    component: VMSWbestuurdersDetail,
    name: 'VMSWbestuurdersDetailUpdate',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWbestuurdersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWbestuurdersDetail/update/:bestuurderid/inzien/:personid',
    component: VMSWbestuurdersDetail,
    name: 'VMSWbestuurdersDetailUpdateInzien',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWbestuurdersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWaandeelhouders',
    component: VMSWaandeelhouders,
    name: 'VMSWaandeelhouders',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWaandeelhouders')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWaandeelhouders/inzien/:personid',
    component: VMSWaandeelhouders,
    name: 'VMSWaandeelhoudersInzien',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWaandeelhouders')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWaandeelhoudersDetail',
    component: VMSWaandeelhoudersDetail,
    name: 'VMSWaandeelhoudersDetail',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWaandeelhoudersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWaandeelhoudersDetail/inzien/:personid',
    component: VMSWaandeelhoudersDetail,
    name: 'VMSWaandeelhoudersDetailInzien',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWaandeelhoudersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWaandeelhoudersDetail/update/:aandeelhouderid',
    component: VMSWaandeelhoudersDetail,
    name: 'VMSWaandeelhoudersDetailUpdate',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWaandeelhoudersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VMSWaandeelhoudersDetail/update/:aandeelhouderid/inzien/:personid',
    component: VMSWaandeelhoudersDetail,
    name: 'VMSWaandeelhoudersDetailUpdateInzien',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VMSWaandeelhoudersDetail')
      next()
    }
  },
  {
    path: '/peapp/:role/VVNpersonHandelingen',
    component: VVNpersonHandelingen,
    name: 'VVNpersonHandelingen',
    beforeEnter: (to, from, next) => {
      addBodyClass('prof_VVNpersonHandelingen')
      next()
    }
  },
  {
    path: '/peapp/public/SPE610ExtOrgSelection/:profgroupID?',
    component: SPE610ExtOrgSelection,
    name: 'SPE610ExtOrgSelection',
    beforeEnter: (to, from, next) => {
      addBodyClass('public_SPE610ExtOrgSelection')

      store.commit('setMenuOptions', {
        loadTopbanner: true,
        loadLangChoice: true,
        loadMenu: false,
        loadFixedLinks: false
      })

      next()
    }
  },
  {
    path: '/peapp/public/SPE620ExtOrgAccountAanvragen/:profgroupID',
    component: SPE620ExtOrgAccountAanvragen,
    name: 'SPE620ExtOrgAccountAanvragen',
    beforeEnter: (to, from, next) => {
      // PublicProfgroup
      util.UsetCookie('PublicProfgroup', to.params.profgroupID)

      addBodyClass('public_SPE620ExtOrgAccountAanvragen')

      store.commit('setMenuOptions', {
        loadTopbanner: true,
        loadLangChoice: true,
        loadMenu: false,
        loadFixedLinks: false
      })

      next()
    }
  },
  {
    path: '/peapp/:role/SPE650BHExtOrgDetails/',
    component: SPE650BHExtOrgDetails,
    name: 'SPE650BHExtOrgDetails',
    beforeEnter: (to, from, next) => {
      addBodyClass('extorg_SPE650BHExtOrgDetails')
      next()
    }
  },
  {
    path: '/peapp/:role/SPE696PatientEnquete/:personid',
    component: SPE696PatientEnquete,
    name: 'SPE696PatientEnquete_beheer',
    beforeEnter: (to, from, next) => {
      addBodyClass('allroles_multisourcefeedback_spe696_pr_patientenquete_overviewv2')
      next()
    }
  },
  {
    path: '/peapp/:role/SPE696PatientEnquete/',
    component: SPE696PatientEnquete,
    name: 'SPE696PatientEnquete',
    beforeEnter: (to, from, next) => {
      addBodyClass('allroles_multisourcefeedback_spe696_pr_patientenquete_overviewv2')
      next()
    }
  },
  {
    path: '/peapp/:role/SPE697PatientEnqueteDetail/:MsfID/:sa/:personid',
    component: SPE697PatientEnqueteDetail,
    name: 'SPE697PatientEnqueteDetail_beheer',
    beforeEnter: (to, from, next) => {
      addBodyClass('allroles_multisourcefeedback_spe697_pr_patientenquete_detailv2')
      next()
    }
  },
  {
    path: '/peapp/:role/Spe010Persoonsgegevens/',
    component: Spe010Persoonsgegevens,
    name: 'Spe010Persoonsgegevens',
    beforeEnter: (to, from, next) => {
      addBodyClass('bh_Spe010Persoonsgegevens')
      next()
    }
  },
  { path: '*', component: PEmenuAspDotNetWrapper },
  { path: '/peapp/*', component: notfoundcomponent }
]

function addBodyClass(rightclass) {
  let arrPageClasses = [
    'Spe015PrPersonAutorisedAdmin',
    'prof_Spe020PrStatusoverzicht',
    'prof_spe021_pr_peactiviteiten',
    'prof_spe671_pr_extorg_myadmins',
    'prof_spe673_pr_extorg_admin_detail',
    'prof_VMSWbestuurders',
    'prof_VMSWbestuurdersDetail',
    'prof_VMSWaandeelhouders',
    'prof_VMSWaandeelhoudersDetail',
    'public_PointsOfInterest',
    'prof_VVNpersonHandelingen',
    'allroles_multisourcefeedback_spe696_pr_patientenquete_overviewv2',
    'bodyPublic public_index'
  ]
  arrPageClasses.forEach(pageclass => {
    $('body').removeClass(pageclass)
  })
  $('body').addClass(rightclass)
}
